import React, { PureComponent } from 'react';
import { Translate }            from 'react-localize-redux';
import { Link }                 from 'gatsby';
import styled                   from 'styled-components';
import Button                   from '../../components/button';
import Section                  from './section';
import titleImg                 from './images/title/FAQ.png';
import QandAList                from '../q-and-a-list';
import { InformationHeading }   from './heading';
import ImgButton                from './images/btn_FAQ.png';

/**
 * Number of FAQs to display
 * Must correspond with locale file
 */
const numOfDefault = 4;

const Container = styled.div``;

const BLANK1 = styled.div`
  margin-top: 1em;
`;
const BLANK2 = styled.div`
  margin-top: 2em;
`;

const MoreLink = styled(Link)`
  width: 17em;
  display: block;
  margin: 2em auto 0;
`;

const Image = styled.img`width: 100%`;

/**
 * Faq section
 */
class Faq extends PureComponent {

  render() {
    const { gameId } = this.props;
    const headerStyle  = {background: '#C2FE08', color: '#111111'};
    const contentStyle = {background: 'black', color: '#C2FE08', border: '1px solid #C2FE08'};

    return (
      <Container>
        <BLANK1 />

        <Section imgSrc={titleImg} titleWidth='100%' >

          <BLANK2 />

          <QandAList
            maxLength={numOfDefault}
            paths={[`/faqs/gameSpecific/${gameId}`, '/faqs/general']}
            styles={{
              header : headerStyle,
              content: contentStyle
            }}
          />
          <MoreLink to={`/games/${gameId}/faqs/`}>
            <Image src={ImgButton}  />
          </MoreLink>

        </Section>
      </Container>
    );
  }
}

export default Faq;
